export enum HistoryTypes {
    INITIAL = 1,
    USER = 2,
    OPERATOR = 3,
    SYSTEM = 4,
    NOTE = 5,
    LOG = 6,
    AUTORESPONDER = 7,
}
